import "./wax-chain";
export async function fetchSimpleAsset(id) {
    const res = await fetch(`https://wax.api.simpleassets.io/v1/assets/${id}`);
    return await res.json();
}
